import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { fetchLinkedRestaurantInvoices } from "../../../../../store/actions";
import moment from "moment";

export const useLinkedBills = (bookingDetails) => {
  const dispatch = useDispatch();
  const [linkedBills, setLinkedBills] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!bookingDetails?.booking_id) return;

    const loadBills = async () => {
      setLoading(true);
      try {
        const response = await dispatch(
          fetchLinkedRestaurantInvoices(bookingDetails.booking_id)
        );

        const data = Array.isArray(response) ? response : response?.data || [];
       const transformedData = data.map(bill => ({
          ...bill,
          date: bill.date 
            ? moment.unix(parseInt(bill.date)).format("DD MMM YYYY")
            : "-"
        }));
        setLinkedBills(transformedData);
      } catch (err) {
        console.error("Failed to load restaurant bills:", err);
        setError("Could not retrieve linked restaurant bills.");
      } finally {
        setLoading(false);
      }
    };

    loadBills();
  }, [bookingDetails?.booking_id, dispatch]);

  return {
    linkedBills,
    loading,
    error,
  };
};
